// import { useEffect, useState } from "react";
// import axios from 'axios';
// import { PiStudentDuotone, PiClockCountdownDuotone, PiNotepadDuotone, PiChatCircleDotsDuotone, PiGitBranchDuotone  } from "react-icons/pi";

// import { LiaDiscourse } from "react-icons/lia";
// import { FaComputer } from "react-icons/fa6";
import { FiHome, FiHardDrive, FiMap, FiLink, FiClipboard, FiShield, FiZap, FiFileText, FiUsers, FiGrid, FiSettings, FiInfo } from "react-icons/fi";
import { NavLink } from 'react-router-dom';

import digicomLogoDark from '../../../assets/images/sec1-logo-svg-orange.svg';
import digicomLogoLight from '../../../assets/images/sec1-logo-svg-orange.svg';
// import { GlobalConst } from "../../../shared/appConfig/globalConst";
// import sidebarInfographic from '../../../assets/images/infographic-sidebar.svg';
import _ from "lodash";
import { useSelector } from "react-redux";

// let instance = axios.create();

export default function Sidebar() {

    const userInfo = useSelector(state => state.authReducer.userDetails);
    // const [quote, setQuote] = useState("Believe in yourself and stay positive!");

    // useEffect(() => {
    //     const fetchQuote = async () => {
    //         try {
    //             const response = await axios.get(`${GlobalConst.API_URL}/api/v1/entrance/todays-quote`);
    //             // console.log(response);
    //             if(!_.isEmpty(response.data) && !_.isEmpty(response.data.message) && response.data.message==='TODAYS_QUOTE'){
    //                 setQuote(response.data.result[0].q);
    //             }
    //             else{
    //                 setQuote("Believe in yourself and stay positive!");
    //             }

    //         } catch (error) {
    //             setQuote("Believe in yourself and stay positive!");
    //         }
    //     };
    //     fetchQuote();
    // }, []);


    return (
        <div id="kt_app_sidebar" className="app-sidebar flex-column" data-kt-drawer="true"
            data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, lg: false}"
            data-kt-drawer-overlay="true" data-kt-drawer-width="250px" data-kt-drawer-direction="start"
            data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle">





            <div className="app-header-logo d-flex align-items-center flex-stack px-lg-11 mb-2"
                id="kt_app_header_logo">
                <div className="btn btn-icon btn-active-color-primary w-35px h-35px ms-3 me-2 d-flex d-lg-none"
                    id="kt_app_sidebar_mobile_toggle">
                    <i className="ki-duotone ki-abstract-14 fs-2">
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                </div>
                <a href="/" className="app-sidebar-logo">
                    <img alt="Logo" src={digicomLogoLight} className="h-30px theme-light-show" />
                    <img alt="Logo" src={digicomLogoDark} className="h-30px theme-dark-show" />
                </a>
                {/* <div id="kt_app_sidebar_toggle" onClick={handleSidebarMinimizeClick}
                        className={`app-sidebar-toggle btn btn-sm btn-icon btn-color-warning me-n2 d-none d-lg-flex ${toggle ? 'active' : ''}`}
                        data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body"
                        data-kt-toggle-name="app-sidebar-minimize">
                        <i className="ki-duotone ki-exit-left fs-2x rotate-180">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </div> */}
            </div>




            <div className="d-flex flex-column justify-content-between h-100 hover-scroll-overlay-y my-2 d-flex flex-column"
                id="kt_app_sidebar_main" data-kt-scroll="true" data-kt-scroll-activate="true"
                data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_app_header"
                data-kt-scroll-wrappers="#kt_app_main" data-kt-scroll-offset="5px">


                <div id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false"
                    className="flex-column-fluid menu menu-sub-indention menu-column menu-rounded menu-active-bg mb-7">
                    <div data-kt-menu-trigger="click" className="menu-item here show menu-accordion">
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <FiHome className="fs-1" />
                            </span>
                            <span className="menu-title">Dashboard</span>
                        </NavLink>
                    </div>

                    {/* New menu items from screenshot */}
                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/assets" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiHardDrive className="fs-1" /></span>
                            <span className="menu-title">Assets</span>
                        </NavLink>
                    </div>

                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/network-map" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiMap className="fs-1" /></span>
                            <span className="menu-title">Network Map</span>
                        </NavLink>
                    </div>


                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/threat-prevention" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiShield className="fs-1" /></span>
                            <span className="menu-title">Threat Prevention</span>
                        </NavLink>
                    </div>

                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/alerts" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiZap className="fs-1" /></span>
                            <span className="menu-title">Alerts <span className="badge bg-danger ms-2">55</span></span>
                        </NavLink>
                    </div>

                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/reports" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiFileText className="fs-1" /></span>
                            <span className="menu-title">Reports</span>
                        </NavLink>
                    </div>

                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/user-management" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiUsers className="fs-1" /></span>
                            <span className="menu-title">User Management</span>
                        </NavLink>
                    </div>

                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/integrations" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiGrid className="fs-1" /></span>
                            <span className="menu-title">Integrations</span>
                        </NavLink>
                    </div>

                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink to="/settings" className={({ isActive }) => `menu-link ${isActive ? 'active' : ''}`}>
                            <span className="menu-icon"><FiSettings className="fs-1" /></span>
                            <span className="menu-title">Settings</span>
                        </NavLink>
                    </div>

                    

                    {/* <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/students"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <PiStudentDuotone className="fs-1" />
                            </span>
                            <span className="menu-title">Students</span>
                        </NavLink>
                    </div> */}

                    {/* <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/courses"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <LiaDiscourse className="fs-1" />
                            </span>
                            <span className="menu-title">Courses</span>
                        </NavLink>
                    </div> */}

                    {/* <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/labs"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <FaComputer className="fs-1" />
                            </span>
                            <span className="menu-title">Labs</span>
                        </NavLink>
                    </div> */}

                    {/* <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/batches"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <PiClockCountdownDuotone className="fs-1" />
                            </span>
                            <span className="menu-title">Batches</span>
                        </NavLink>
                    </div>

                    <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/notes"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <PiNotepadDuotone className="fs-1" />
                            </span>
                            <span className="menu-title">Notes</span>
                        </NavLink>
                    </div> */}

                    {/* <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/feedback"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <PiChatCircleDotsDuotone className="fs-1" />
                            </span>
                            <span className="menu-title">Feedback</span>
                        </NavLink>
                    </div>

                    {userInfo.userDesignation==='Admin' &&<div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/branches"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <PiGitBranchDuotone  className="fs-1" />
                            </span>
                            <span className="menu-title">Branches</span>
                        </NavLink>
                    </div>} */}

                    {/* <div data-kt-menu-trigger="click" className="menu-item menu-accordion">
                        <NavLink
                            to="/help"
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            <span className="menu-icon">
                                <i className="ki-duotone ki-rescue fs-1">
                                    <span className="path1"></span>
                                    <span className="path2"></span>
                                </i>
                            </span>
                            <span className="menu-title">Help</span>
                        </NavLink>
                    </div> */}
                </div>

                {/* <div className="app-sidebar-project-default app-sidebar-project-minimize text-center min-h-lg-400px flex-column-auto d-flex flex-column justify-content-end"
                    id="kt_app_sidebar_footer">
                    <h2 className="fw-bold text-gray-800">Welcome to Digicom</h2>
                    <div className="fw-semibold text-gray-700 fs-7 lh-2 px-7 mb-1">{quote}</div>
                    <img className="mx-auto h-150px h-lg-175px mb-4" src={sidebarInfographic} alt="info" />
                </div> */}
            </div>
        </div>)
}